import { type ClassValue, clsx as clsxInit } from "clsx"
import { twMerge } from "tailwind-merge"

export type { ClassValue }

export function clsx(...inputs: ClassValue[]) {
    return twMerge(clsxInit(inputs))
}
